export const MAINTENANCE_TASK_PROCESS_STEP_QUICK_FIX_TYPE_FIELD_NAME = "type";
